/* istanbul ignore file */
import React from 'react';
import { EnumField, FieldProps } from 'framework/ui/field';
import { useShowContext } from 'framework/show';
import { LEAD_SOURCE } from 'domain/sales/lead/shared/leadService';

const LeadSourceField = ({ value: inputValue = null, source = null }: FieldProps) => {
  const { data } = useShowContext();

  const value = inputValue || (data && data.getValueBySource(source));

  return <EnumField label="Lead source" value={value} options={LEAD_SOURCE} />;
};

export default LeadSourceField;
